var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{ref:"selector",attrs:{"async":true,"load-options":_vm.loadOptions,"loading":_vm.looking,"multiple":_vm.multiple,"openDirection":"bottom","placeholder":"Typ om te zoeken..."},model:{value:(_vm.currentObject),callback:function ($$v) {_vm.currentObject=$$v},expression:"currentObject"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }